import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

const ReservationBadges = ({ reservation }) => {
  const badges = []

  // Space Type Badge
  if (reservation.requestedSpaceType) {
    badges.push(
      <Badge
        key="space-type"
        color="neutral"
        text={
          reservation.requestedSpaceType.charAt(0).toUpperCase() +
          reservation.requestedSpaceType.slice(1)
        }
      />
    )
  }

  // Wide Beam Badge
  if (reservation.wideBeam) {
    badges.push(<Badge key="wide-beam" color="warning" text="Wide Beam" />)
  }

  // Special Request Badge
  if (reservation.specialRequest) {
    badges.push(
      <Badge key="special-request" color="positive" text="Special Request" />
    )
  }

  // Check-in Status Badges
  if (reservation.checkedInNotOut) {
    badges.push(
      <Badge
        key="checked-in"
        color={statusToken("Checked In")}
        text="Checked In"
      />
    )
  }

  if (reservation.checkedOut) {
    badges.push(
      <Badge
        key="checked-out"
        color={statusToken("Checked Out")}
        text="Checked Out"
      />
    )
  }

  // Payment Status Badges
  if (reservation.unpaidNotPending) {
    badges.push(
      <Badge key="unpaid" color={statusToken("Unpaid")} text="Unpaid" />
    )
  } else if (reservation.addCardLater) {
    badges.push(
      <Badge key="missing-card" color="warning" text="Missing Card" />
    )
  }

  // Communication Badge
  if (reservation.unreadBoaterMessages) {
    badges.push(
      <span
        key="unread-message"
        className="label label-inline-block label-danger"
      >
        Unread Message
      </span>
    )
  }

  // Manual Approval Badge
  if (reservation.contactRequiresManualApproval) {
    badges.push(
      <Badge key="manual-approval" color="warning" text="See Customer Note" />
    )
  }

  return (
    <div
      className="flex flex-wrap items-center justify-start gap-1.5 py-2"
      style={{ fontSize: "1.1em" }}
    >
      {badges}
    </div>
  )
}

ReservationBadges.propTypes = {
  reservation: PropTypes.shape({
    belongsToContract: PropTypes.bool,
    contractGroupName: PropTypes.string,
    requestedSpaceType: PropTypes.string,
    wideBeam: PropTypes.bool,
    specialRequest: PropTypes.bool,
    checkedInNotOut: PropTypes.bool,
    checkedOut: PropTypes.bool,
    unpaidNotPending: PropTypes.bool,
    addCardLater: PropTypes.bool,
    unreadBoaterMessages: PropTypes.bool,
    contactRequiresManualApproval: PropTypes.bool,
  }).isRequired,
}

export default ReservationBadges
